<div *ngIf="getClientsSettingAppBooking" (click)="_onClick()" id='home'>
    <usb-search-box [reloadCategories]="reloadCategories" [_close]="_close" (modal)="openModal($event)" (payload)="_onPayload($event)" (results)="_onResults($event)"
      (isLoading)="_onLoading($event)" (origin)="_onOrigin($event)">
    </usb-search-box>
    <usb-destination-big [getClientsSettingAppBooking]="getClientsSettingAppBooking"></usb-destination-big>
    <usb-destination-small [getClientsSettingAppBooking]="getClientsSettingAppBooking"></usb-destination-small>
    <usb-capacitation [getClientsSettingAppBooking]="getClientsSettingAppBooking"></usb-capacitation>
    <usb-shortcuts></usb-shortcuts>
</div>
